import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import { ArrowRight } from '../ui/Vectors';
import '../css/screens/PerspectivePage.scss';
import Spacer from '../ui/Spacer';

export default class PerspectivePage extends Page {

	render() {
		return this.wrap(
			<React.Fragment>
				<div className='header'>
					<Grid cols={2} breakpoints={{small: 4}} className="padding">
						<h1>{this.props.content.title}</h1>
					</Grid>
					<Grid cols={2} breakpoints={{small: 4}} className="padding">
						<div className='text'>{this.props.content.text}</div>
					</Grid>
				</div>
				<Grid cols={4}>
					{this.props.content?.items?.map((item, i)=>{
						return (<PerspectiveItem content={item} key={'perspective' + i}></PerspectiveItem>);
					})}
				</Grid>
			</React.Fragment>
		);
	}
}

class PerspectiveItem extends React.Component<{content}>
{
	render()
	{
		let description:any = this.props.content.description;
		let splitted = description.split(/([\(|（].*?[\)|）])/);
		let o;
		description = splitted.map((e, i)=>{
			if(o = /^([\(|（].*?[\)|）])$/.exec(e))
			{
				return (
					<span className='description-small' key={Math.random()}>{o[1]}</span>
				);
			}else{
				return e;
			}
		});
	
		return (
			<div className='perspectiveItem'>
				<Grid cols={4} skip={0}>
					<img src={this.props.content.image.src} width={this.props.content.image.width} height={this.props.content.image.height} />
				</Grid>
				<Grid cols={1}>
					<div className="tag hide-small">{this.props.content.tag}</div>
				</Grid>
				<Grid cols={2} breakpoints={{small: {cols: 4, skip: 0}}} className="padding">
					<Grid cols={4} breakpoints={{small: 4}}>
						<div className='title'>{this.props.content.title}</div>
					</Grid>
					<Grid cols={4}>
						<div className='description'>{description}</div>
						<div className='text'>{this.props.content.text}</div>
					</Grid>
				</Grid>
				<Grid cols={1} breakpoints={{small: {cols: 4}}} className="vertical-bottom padding">
					<Button link={this.props.content.button.link} className="flex flex-column flex-right">
						<span className="text-right flex-self-right">
							<div>{this.props.content.button.label}</div>
							<ArrowRight className='arrow'></ArrowRight>
						</span>
					</Button>
				</Grid>
			</div>
		);
	}
}
